import { gql } from "lib/apolloClient";

export const updateAssessmentToolTemplateConfigMutation = gql`
  mutation updateAssessmentToolTemplateConfig(
    $input: UpdateAssessmentToolTemplateConfigInput!
  ) {
    planner {
      updateAssessmentToolTemplateConfig(input: $input) {
        isSuccess
        warning
        response {
          id
          toolType
          config
        }
      }
    }
  }
`;
